module.exports = __webpack_public_path__ + "img/patent05.a79f48fd.png";